import { type z } from 'zod';

import { client } from '@@api/client';
import config from '@@config';
import { unitySearchParams } from '@@containers/Search/unitySearchParams';

import { DEFAULT_REFETCH_INTERVAL } from '../constants';

const DEFAULT_SORT = 'startTime,desc';

export const abTestsSearchParams = unitySearchParams.pick({
    q: true,
    page: true,
    sort: true,
    statuses: true,
});

type AbTestsSearchParams = z.output<typeof abTestsSearchParams>;

// With a text, the API ranks by relevance unless the user picked a column
export const abTestsSort = (search: AbTestsSearchParams) =>
    search.sort ?? (search.q ? undefined : DEFAULT_SORT);

export const abTestsQuery = (search: AbTestsSearchParams) =>
    client.abTests.teaser.getAll.queryOptions(
        {
            query: {
                sort: abTestsSort(search),
                q: search.q,
                statuses: search.statuses,
                size: config.list.itemsPerPage,
                page: (search.page ?? 1) - 1,
            },
        },
        { refetchInterval: DEFAULT_REFETCH_INTERVAL },
    );
